<template>
<div>

    <v-select
        label="Send Mode"
        :items="send_modes"
        :value="value.send_mode"
        v-on:change="onChangeSendMode"
        :disabled="disable_mode"
    />

    <v-alert
      border="left"
      colored-border
      color="primary"
      elevation="2"
      type="info"
      dismissible
      v-if="value.send_from == null"
    >
      <b>Warning:</b> No messages will be <span v-if="value.send_mode == 'auto'">sent</span><span v-else>generated</span> because you have not yet selected a send from number
   </v-alert>

    <m-edit-select-organization-owned-endpoint
        label="Send From"
        :organization_id="value.organization_id"
        v-model="value.send_from"
        v-on:input="onChangeSendFrom"
    />

    <v-select
        label="Link Shortener Host"
        :items="link_shortener_host_choices"
        :value="value.link_shortener_host"
        
        v-on:change="onChangeLinkShortener"
    />

    <m-edit-message-patterns-compact
        :value="value.message_patterns"
        :context="message_pattern_context"
        v-on:input="onChangeMessagePatterns"
        style="margin-top: 15px; margin-bottom: 30px"
    />

    <m-edit-blobs
        label="Image (optional)"
        empty_text="No image"
        v-model="value.blob_ids"
        v-on:input="onChangeBlobs"
        :process_media="true"
        :externally_visible="true"
        :allow_multiple="false"
        :limit_to_size="460800"
        style="padding-bottom: 7px; margin-bottom: 15px; border-bottom: 1px solid rgb(148,148,148); margin-top: 15px"
        edit_icon="mdi-lead-pencil"
        dialog_title="Select Image"
        dialog_hint="<b>Image limitations:</b>  Images <b>must</b> be 450 Kb or smaller.<br/><br/><b>Image size:  </b>For best results, images should be square or close to square.  The ideal image size is 400 x 400 pixels."
    />

    <m-select-vcard
        label="Attach contact card (optional)"
        v-model="value.vcard_id"
        v-on:input="onChangeVCard"
        ref="select-contact-card"
        style="margin-top: 15px"
    />

    <v-row
        v-if="default_message_control"
    >
        <v-col>
            <m-edit-text
                label="Delay before sending"
                :value="value.time_delay_send_after_enqueue"
                duration
                v-on:input="onChangeDelayBeforeSendingDefault"
            />
        </v-col>

        <v-col>
            <m-edit-text
                label="Expire if not sent within"
                :value="value.time_delay_expire_after_trigger"
                duration
                v-on:input="onChangeExpirationDefault"
            />
        </v-col>
    </v-row>

    <v-row
        v-if="!default_message_control"
    >
        <v-col>
            <m-edit-text
                label="Custom delay before sending"
                :value="value.custom_time_delay_send_after_enqueue"
                duration
                v-on:input="onChangeDelayBeforeSendingCustom"
                unset_label="Remove"
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Custom expire if not sent within"
                :value="value.custom_time_delay_expire_after_trigger"
                duration
                v-on:input="onChangeExpirationCustom"
                unset_label="Remove"
            />
        </v-col>
    </v-row>

    <v-alert
      v-if="value.time_delay_send_after_enqueue >= value.time_delay_expire_after_trigger"  
      color="primary"
      elevation="2"
      type="error"
    >
      With the "expire if not sent within" time set to less than or equal to the "delay before sending" <b><u>every message will expire before it is sent.</u></b>
   </v-alert>

</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {

        message_pattern_context: {
            type: String,
            default: function() { return ''; }
        },

        send_from_choices: {
            type: Array,
            default: function() { return []; }
        },

        value: {
            type: Object,
            default: function() { return []; }
        },

        link_shortener_host_choices: {
            type: Array,
            default: function() { return []; }
        },

        disable_mode: {
            type: Boolean,
            default: function() { return false; }
        },

        default_message_control: {
            type: Boolean,
            default: function() { return false; }
        }
    },

    data() {
        return {
             send_modes: [
                { 'text' : 'Disabled', 'value' : 'disabled'},
                { 'text' : 'Manual', 'value' : 'manual'},
                { 'text' : 'Automatic', 'value' : 'auto'},
            ],
        }
    },

    methods: {
        onChangeMessagePatterns(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.message_patterns = new_value;
            this.$emit('input', emit_value);
        },

        onChangeBlobs(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.blob_ids = new_value;
            this.$emit('input', emit_value);
        },

        onChangeVCard(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.vcard_id = new_value;
            this.$emit('input', emit_value);
        },

        onChangeSendMode(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.send_mode = new_value;
            this.$emit('input', emit_value);
        },

        onChangeSendFrom(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.send_from = new_value;
            this.$emit('input', emit_value);
        },

        onChangeLinkShortener(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.link_shortener_host = new_value;
            this.$emit('input', emit_value);
        },

        onChangeDelayBeforeSendingDefault(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.time_delay_send_after_enqueue = new_value;
            this.$emit('input', emit_value);
        },

        onChangeExpirationDefault(new_value)
        {
            if ( new_value == 0 )
            {
                this.$rc.alert('Invalid expire if not sent within', 'You may not set the expiration to zero -- all messages will immediately expire<br/><br/>No changes have been made.');
                return;
            }

            let emit_value = _.cloneDeep(this.value);
            emit_value.time_delay_expire_after_trigger = new_value;
            this.$emit('input', emit_value);
        },

        onChangeDelayBeforeSendingCustom(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.custom_time_delay_send_after_enqueue = new_value;
            this.$emit('input', emit_value);
        },

        onChangeExpirationCustom(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.custom_time_delay_expire_after_trigger = new_value;
            this.$emit('input', emit_value);
        },
    },

}
</script>

<style lang="scss" scoped>

</style>